/**
 * Constantes globais do sistema
 */

// Paginação padrão
export const PAGE_SIZE = 50;

// Status de veículos
export const veiculoStatusLabels: Record<string, string> = {
  DISPONIVEL: 'Disponível',
  RESERVADO: 'Reservado',
  VENDIDO: 'Vendido',
  EM_PREPARACAO: 'Em Preparação',
};

export const veiculoStatusColors: Record<string, string> = {
  DISPONIVEL: 'bg-green-100 text-green-800',
  RESERVADO: 'bg-yellow-100 text-yellow-800',
  VENDIDO: 'bg-blue-100 text-blue-800',
  EM_PREPARACAO: 'bg-orange-100 text-orange-800',
};

// Tipo de pessoa (clientes/fornecedores)
export const tipoPessoaLabels: Record<string, string> = {
  PF: 'Pessoa Física',
  PJ: 'Pessoa Jurídica',
};

export const tipoPessoaColors: Record<string, string> = {
  PF: 'bg-blue-100 text-blue-800',
  PJ: 'bg-green-100 text-green-800',
};

// Status de vendas
export const vendaStatusLabels: Record<string, string> = {
  PROPOSTA: 'Proposta',
  APROVADA: 'Aprovada',
  FATURADA: 'Faturada',
  ENTREGUE: 'Entregue',
  CANCELADA: 'Cancelada',
};

export const vendaStatusColors: Record<string, string> = {
  PROPOSTA: 'bg-yellow-100 text-yellow-800',
  APROVADA: 'bg-blue-100 text-blue-800',
  FATURADA: 'bg-green-100 text-green-800',
  ENTREGUE: 'bg-purple-100 text-purple-800',
  CANCELADA: 'bg-red-100 text-red-800',
};

// Status de tarefas
export const tarefaStatusLabels: Record<string, string> = {
  PENDENTE: 'Pendente',
  EM_ANDAMENTO: 'Em Andamento',
  CONCLUIDA: 'Concluída',
  CANCELADA: 'Cancelada',
};

export const tarefaStatusColors: Record<string, string> = {
  PENDENTE: 'bg-yellow-100 text-yellow-800',
  EM_ANDAMENTO: 'bg-blue-100 text-blue-800',
  CONCLUIDA: 'bg-green-100 text-green-800',
  CANCELADA: 'bg-red-100 text-red-800',
};

// Prioridades de tarefas/leads
export const prioridadeLabels: Record<string, string> = {
  BAIXA: 'Baixa',
  MEDIA: 'Média',
  ALTA: 'Alta',
  URGENTE: 'Urgente',
};

export const prioridadeColors: Record<string, string> = {
  BAIXA: 'bg-gray-100 text-gray-800',
  MEDIA: 'bg-blue-100 text-blue-800',
  ALTA: 'bg-orange-100 text-orange-800',
  URGENTE: 'bg-red-100 text-red-800',
};

// Temperatura de leads
export const temperaturaLabels: Record<string, string> = {
  FRIO: 'Frio',
  MORNO: 'Morno',
  QUENTE: 'Quente',
};

export const temperaturaColors: Record<string, string> = {
  FRIO: 'bg-blue-100 text-blue-800',
  MORNO: 'bg-yellow-100 text-yellow-800',
  QUENTE: 'bg-red-100 text-red-800',
};

// Tipos de custo de veículo
export const tipoCustoLabels: Record<string, string> = {
  DOCUMENTACAO: 'Documentação',
  MANUTENCAO: 'Manutenção',
  ESTETICA: 'Estética',
  ACESSORIO: 'Acessório',
  OUTROS: 'Outros',
};

export const tipoCustoColors: Record<string, string> = {
  DOCUMENTACAO: 'bg-blue-100 text-blue-800',
  MANUTENCAO: 'bg-orange-100 text-orange-800',
  ESTETICA: 'bg-purple-100 text-purple-800',
  ACESSORIO: 'bg-green-100 text-green-800',
  OUTROS: 'bg-gray-100 text-gray-800',
};

// Re-export integracoes
export * from './integracoes';
